import ImpressumLink from './ImpressumLink'

export default ImpressumLink
